<template>
  <div class="post-item">
    <div
      class="content-bloc"
      :class="{ bazar: postContent.opinion }"
    >
      <div class="content-item">
        <PostContent
          :post="postContent"
          :source="source"
        />
      </div>
    </div>
    <div class="side-bloc">
      <div class="diagonal">
        <div class="top-grey" />
      </div>
      <PostSide
        :side="sideContent"
        class="side-item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PostContent, SideContent } from '~/types'

withDefaults(
  defineProps<{
    source?: boolean
    postContent: PostContent
    sideContent: SideContent
  }>(),
  {
    source: false,
  },
)
</script>

<style lang="scss" scoped>
.post-item {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .content-bloc {
    width: calc(100vw - 74.2rem);
    padding: 5rem 8rem;

    &.bazar {
      padding-top: 6rem;
    }
  }

  .side-bloc {
    position: relative;
    flex-shrink: 0;
    width: 74.2rem;

    .diagonal {
      position: absolute;
      top: -5rem;
      left: 0;
      z-index: 3;
      display: inline-block;
      width: 100%;
      height: 5rem;
      overflow: hidden;

      .top-grey {
        position: absolute;
        top: 0;
        left: calc(-100vw + 74.2rem);
        z-index: 2;
        width: 0;
        height: 0;
        border-width: 0 0 5rem 100vw;
        border-style: solid;
        border-color: transparent transparent $sideGrey transparent;
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .post-item {
    .content-bloc {
      width: calc(100vw - 58.2rem);
    }

    .side-bloc {
      width: 58.2rem;

      .diagonal {
        .top-grey {
          left: calc(-100vw + 58.2rem);
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .post-item {
    flex-direction: column;

    .content-bloc {
      width: 100%;
    }

    .side-bloc {
      width: 100%;

      .diagonal {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .post-item {
    flex-direction: column;

    .content-bloc {
      padding-right: 2.5rem;
      padding-bottom: 4rem;
      padding-left: 2.5rem;
    }

    .side-bloc {
      width: 100%;

      .diagonal {
        display: none;
      }
    }
  }
}

@media screen and (min-width: 2000px) {
  .post-item {
    .content-bloc {
      display: flex;
      justify-content: flex-end;
      width: calc(50vw - 100rem + 125.8rem);

      .content-item {
        width: 109.8rem;
      }
    }

    .side-bloc {
      display: flex;
      justify-content: flex-start;
      width: calc(50vw - 100rem + 74.2rem);
      background: $sideGrey;

      .side-item {
        width: 74.2rem;
      }

      .diagonal {
        .top-grey {
          left: calc(-1 * (50vw - 100rem + 125.8rem));
        }
      }
    }
  }
}
</style>
